__turbopack_context__.v({
  "horizontalCardContent": "mPb6rG_horizontalCardContent",
  "horizontalCardInfo": "mPb6rG_horizontalCardInfo",
  "horizontalCardInfoHasVideo": "mPb6rG_horizontalCardInfoHasVideo",
  "horizontalCardMedia": "mPb6rG_horizontalCardMedia",
  "horizontalCardMediaHasVideo": "mPb6rG_horizontalCardMediaHasVideo",
  "horizontalCardWrapper": "mPb6rG_horizontalCardWrapper",
});
